import React from 'react';
import styled from '@emotion/styled';

import { StoreZigzinDelayFourDays, StoreZigzinDelaysTwoDay, StoreZigzinDelayThreeDays } from '../../constant/imageUrl';

interface Props {
  days: number;
}

export const StoreZigzinDelayDays: React.FC<React.PropsWithChildren<Props>> = ({ days }) => {
  switch (days) {
    case 2:
      return <IslandDelayDays src={StoreZigzinDelaysTwoDay} />;
    case 3:
      return <IslandDelayDays src={StoreZigzinDelayThreeDays} />;
  }

  if (days >= 4) {
    return <IslandDelayDays src={StoreZigzinDelayFourDays} />;
  }

  return null;
};
const IslandDelayDays = styled.img`
  margin: 0 0 0 4px;
  width: auto;
  height: 18px;
`;
